<div class="calendar-box">
    <div [class.loading-calendar]="!isReady" [hidden]="loadingComponentUnits.isHidden">
        <loading-component [class.loading-center]="!isReady" #loadUnits></loading-component>
    </div>
    <div [ngClass]="{'todayCSS':todayCSS,'selectCSS':selectCSS}" class="calendar-component">
        <mat-calendar [style.opacity]="!isReady ? '0.8': '1'" [selected]="dateSelected" name="date" [(ngModel)]="date"
            [dateFilter]="myFilter" [minDate]="now" [startAt]="start" (selectedChange)="changeDate($event)" ngDefaultControl></mat-calendar>
    </div>
</div>